(function () {
    'use strict';

    function partnerSelector($state, $mdDialog, $timeout, $rootScope,
            searchDataService, workflowStateService, notifyService,
            mailRequestDataService, sessionDataService, platformEntityReferralDataService) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/partnerSelector.html',
            scope: {
                phaseIndex: '@',
                path: '@',
                partners: '=',
                referrals: '=',
                canAddPartners: '=',
                maxPartnersToShow: '@?',
                showAddPartnersPrompt: '=?',
                popoverConfig: '='
            },
            link: function (scope, element, attrs) {
                // data initialization
                scope.workflowData = workflowStateService.get();
                scope.expandedPartners = scope.partners.filter(function () { return true; });
                scope.expandedPartners.forEach(function (p) {
                    p.IconText = p.Contact.FirstName.substring(0,1) + p.Contact.LastName.substring(0,1);
                });

                scope.pathObject = workflowStateService.getObjectFromPath(scope.workflowData, scope.path);
                scope.pathAccess = scope.pathObject.Access;

                scope.expandedReferrals = scope.referrals.filter(function (referral) {
                    return scope.expandedPartners.every(function (partner) {
                        return partner.UserName !== referral.EmailAddress;
                    });
                });

                scope.expandedReferrals.forEach(function (r) {
                    if (!r.Data || !r.Data.Permissions) {
                        r.Data = {
                            Permissions: {
                                View: true,
                                Edit: true,
                                Share: true,
                                Notes: true
                            }
                        }
                    }
                });

                scope.isSharingButtonActive = true;
                scope.totalPartnersCount = scope.expandedPartners.length + scope.expandedReferrals.length;

                if (scope.path === "") {
                    scope.pathMarker = "Project ";
                }

                scope.owner = scope.workflowData.Entity;
                scope.owner.IconText = scope.owner.Contact.FirstName.substring(0,1) + scope.owner.Contact.LastName.substring(0,1);
                scope.canEditOwnerPermissions = (scope.path == '') &&
                    ((scope.workflowData.AccessLevel === 'ProjectAdmin') ||
                    (scope.workflowData.AccessLevel === 'ProjectOwner'));
                scope.owner.Edit = !scope.workflowData.AdminConfigModifyingOnly;
                scope.owner.Share = !scope.workflowData.AdminSharingOnly;
                scope.owner.Notes = !scope.workflowData.AdminUnderwritingNotesOnly;
                sessionDataService.loadSession().then(function (sessionData) {
                    scope.sessionData = sessionData;
                });

                scope.canManagePartnerPermissions = (scope.workflowData.AccessLevel === "ProjectOwner" && scope.owner.Share) ||
                    scope.workflowData.AccessLevel === "ProjectAdmin";

                // visibility
                scope.showPartnersMenu = false;
                scope.togglePartnersMenu = function($event) {
                    if (!scope.showPartnersMenu) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        scope.showPartnersMenu = true;
                    }
                }

                $rootScope.$on('popoverOpened', function (event, args) {
                    if (args.type === 'popoverOpened') {

                    }
                });

                // manage owner
                scope.toggleManageOwner = function () {
                    scope.owner.IsExpanded = !scope.owner.IsExpanded;
                }

                scope.toggleOwnerPermission = function (permission) {
                    $timeout(function() {
                        var permissionValue = false;
                        switch (permission) {
                            case ('Edit'):
                                permission = 'AdminConfigModifyingOnly';
                                permissionValue = !scope.owner.Edit;
                                break;
                            case ('Share'):
                                permission = 'AdminSharingOnly';
                                permissionValue = !scope.owner.Share;
                                break;
                            case ('Notes'):
                                permission = 'AdminUnderwritingNotesOnly';
                                permissionValue = !scope.owner.Notes;
                                break;
                        }
                        scope.workflowData[permission] = permissionValue;
                        workflowStateService.update(scope.workflowData);
                        notifyService.notify('You modified a project owner permission');
                    }, 0);
                }

                // manage partner
                scope.toggleManagePartner = function (partner) {
                    partner.IsExpanded = !partner.IsExpanded;
                }

                scope.toggleSharingPermission = function (partner, permission, value) {
                    $timeout(function() {
                        var entityConnection = scope.workflowData.SharingConnections.find(function(connection) {
                            return connection.EntityId === partner.Id;
                        });

                        if (!entityConnection) {
                            notifyService.notify('There was an error toggling this permission', true)
                        }

                        var index = entityConnection.PathsAndPermissions
                            .map(function(pathAndPermission) { return pathAndPermission.Path; }).indexOf(scope.path);
                        var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;

                        entityConnection.PathsAndPermissions[index].Permissions[permission] =
                            value;

                        var projectLevelChanges = false;
                        if (scope.path === "") {
                            projectLevelChanges = entityConnection.PathsAndPermissions.some(function(pathAndPermission) {
                                return pathAndPermission.Path !== "";
                            });

                            entityConnection.PathsAndPermissions.forEach(function(pathAndPermission) {
                                pathAndPermission.Permissions[permission] =
                                    entityConnection.PathsAndPermissions[index].Permissions[permission];
                            });
                        }

                        workflowStateService.update(scope.workflowData);
                        notifyService.notify('You changed sharing permissions for ' +
                            cleanPath +
                            ' for ' +
                            entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName
                            (projectLevelChanges
                                ? '. Please note: project level changes can affect other sharing permissions.'
                                : ''));
                    }, 0);
                }

                scope.togglePartnerVisibility = function (partner) {
                    var entityConnection = scope.workflowData.SharingConnections.find(function (connection) {
                        return connection.EntityId === partner.Id;
                    });

                    var connectionPathAndPermissions = entityConnection.PathsAndPermissions.find(function(pathAndPermissions) {
                        return scope.path === pathAndPermissions.Path;
                    });

                    var index = entityConnection.PathsAndPermissions.findIndex(function (pathAndPermission) { 
                        return pathAndPermission.Path === scope.path;
                    });
                    var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;

                    connectionPathAndPermissions.IsPrivate = !connectionPathAndPermissions.IsPrivate;

                    var projectLevelChanges = (scope.path === "");
                    if (scope.path === "") {
                        entityConnection.PathsAndPermissions.forEach(function (pathAndPermission) {
                            pathAndPermission.IsPrivate = entityConnection.PathsAndPermissions[index].IsPrivate;
                        });
                    }

                    workflowStateService.update(scope.workflowData);
                    notifyService.notify('You changed the sharing visibility for ' +
                        entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName +
                        ' to ' + (entityConnection.IsPrivate ? ' hidden' : 'visible') + ' for ' + cleanPath + '.' +
                        (projectLevelChanges ? 'Please note, that other sharing visibilities have been changed since you made a change at the project level.' : ''));
                }

                scope.removeSharingConnection = function(partner) {
                    var entityConnection = scope.workflowData.SharingConnections.find(function(connection) {
                        return connection.EntityId === partner.Id;
                    });
        
                    var index = entityConnection.PathsAndPermissions.findIndex(function (pathAndPermission) {
                        return pathAndPermission.Path === scope.path; });
                    var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;
                    entityConnection.PathsAndPermissions.splice(index, 1);
        
                    if (entityConnection.PathAndPermissionMappings.length === 0) {
                        scope.workflowData.SharingConnections.splice(
                            scope.workflowData.SharingConnections.indexOf(entityConnection), 1);
                    }

                    workflowStateService.update(scope.workflowData);
                    var index = scope.expandedPartners.findIndex(function (p) { return p.Id === partner.Id });
                    scope.expandedPartners[index].IsRemoved = true;
                    scope.totalPartnersCount--;

                    notifyService.notify('You unshared ' + cleanPath + ' with ' +
                        entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName);
                }

                // manage referral
                scope.toggleManageReferral = function (referral) {
                    referral.IsExpanded = !referral.IsExpanded;
                }

                scope.toggleReferralPermission = function (referral) {
                    platformEntityReferralDataService.updatePlatformEntityReferral(
                        referral.Id.split('/')[1], {
                            ObjectId: scope.workflowData.Id,
                            ObjectPath: scope.path,
                            ObjectData: referral.Data
                        }
                    ).then(function () {
                        notifyService.notify('You changed sharing permissions for ' +
                        referral.cleanPath +
                        ' for ' +
                        referral.EmailAddress +
                        (scope.path === ""
                            ? '. Please note: project level changes can affect other sharing permissions.'
                            : ''));
                    });
                }

                scope.toggleReferralVisibility = function (partner) {
                    platformEntityReferralDataService.updatePlatformEntityReferral(
                        referral.Id.split('/')[1], {
                            ObjectId: scope.workflowData.Id,
                            ObjectPath: scope.path,
                            ObjectData: referral.Data
                        }
                    ).then(function () {
                        notifyService.notify('You changed the sharing visibility for ' +
                        referral.EmailAddress +
                        ' to ' + (referral.Data.IsPrivate ? ' hidden' : 'visible') + ' for ' + referral.cleanPath + '.' +
                        (scope.path === "" ? 'Please note, that other sharing visibilities have been changed since you made a change at the project level.' : ''));
                    });
                }

                scope.removeReferral = function(referral) {
                    platformEntityReferralDataService.removePlatformEntityReferral(
                        referral.Id.split('/')[1], scope.workflowData.Id, scope.path
                    ).then(function () {
                        referral.IsRemoved = true;
                        scope.totalPartnersCount--;
                        notifyService.notify('You unshared ' + referral.cleanPath + ' with ' +
                        referral.EmailAddress);
                    });
                }

                // search
                scope.partnerSearch = {
                    addPartnerSearchValue: ''
                };
                scope.partnerSearchResults = [];
                scope.showInviteMessage = false;

                function clearSearch() {
                    scope.partnerSearchResults = [];
                    scope.partnerSearchResultsTotalItems = null;
                    scope.showInviteMessage = false;
                    scope.partnerSearch.addPartnerSearchValue = '';
                    scope.showInvalidEmailMessage = false;
                }

                scope.getPartnerSearchResults = function () {
                    if (!scope.partnerSearch.addPartnerSearchValue || scope.partnerSearch.addPartnerSearchValue.trim().length == 0) {
                        clearSearch();
                        return;
                    }

                    if (scope.partnerSearch.addPartnerSearchValue !== '') {
                        var predicates = {};
                        predicates.ContactName = {
                            value: scope.partnerSearch.addPartnerSearchValue,
                            condition: "StartsWith",
                            watch: function () { return true; }
                        };

                        var queryModel = {
                            uri: '[BuildifyApiHost]/api/search/entities',
                            pageSize: 10,
                            pageNum: 0,
                            numPages: 0,
                            orderBy: 'ContactName',
                            orderByDirection: 'ascending',
                            predicates: predicates,
                            injectedPredicates: [],
                            defaultPredicates: []
                        };

                        searchDataService.getResults(queryModel).then(function (data) {
                            var existingShares = scope.expandedPartners.filter(function (p) { return !p.IsRemoved; })
                                .map(function (partner) { return partner.Id; })
                            existingShares.push(scope.owner.Id);

                            var filteredResults = data.Results.filter(function (result) {
                                return existingShares.indexOf(result.Id) == -1;
                            });
                            if (filteredResults.length > 0) {
                                scope.showInviteMessage = false;
                                filteredResults.forEach(function (p) {
                                    p.IconText = p.Contact.FirstName.substring(0,1) + p.Contact.LastName.substring(0,1);
                                });
                                scope.partnerSearchResults = filteredResults;
                            } else {
                                scope.partnerSearchResults = [];
                                if (scope.partnerSearch.addPartnerSearchValue.trim().length > 0) {
                                    scope.showInviteMessage = true;
                                }
                            }
                        });
                    }
                }

                scope.addSharingConnection = function (partner) {
                    scope.isSharingButtonActive = false;
                    var permissions = {
                        View: true,
                        Edit: true,
                        Share: true,
                        Notes: true
                    };
                    var matchingPartner = scope.workflowData.SharingConnections.find(function (connection) {
                        return connection.EntityId === partner.Id;
                    });
        
                    if (matchingPartner) {
                        matchingPartner.PathsAndPermissions.push({
                            Path: scope.path,
                            Permissions: {
                                View: true,
                                Edit: true,
                                Share: true,
                                Notes: true
                            }
                        });
                        // scroll and notify
                        notifyService.notify('You shared ' + workflowStateService.getCleanPath(scope.path) + ' with ' + matchingPartner.Entity.CompanyDetails.Name);
                    } else {
                        scope.workflowData.SharingConnections.push({
                            EntityId: partner.Id,
                            PathsAndPermissions: [
                            {
                                Path: scope.path,
                                Permissions: permissions
                            }],
                            Entity: partner
                        });
                        notifyService.notify('You shared ' + workflowStateService.getCleanPath(scope.path) + ' with ' + partner.CompanyDetails.Name);
                    }

                    // update sharing partners for path
                    workflowStateService.update(scope.workflowData);

                    mailRequestDataService.sendWorkflowSharingUpdate({
                        EntityId: scope.workflowData.Entity.Id,
                        SharedWithEntityId: partner.Id,
                        WorkflowId: scope.workflowData.Id
                    });

                    // remove from search results and add to expanded partners
                    partner.Permissions = permissions;
                    partner.IsPrivate = false;
                    partner.IconText = partner.Contact.FirstName.substring(0,1) + partner.Contact.LastName.substring(0,1);

                    scope.expandedPartners.push(Object.assign({}, partner));
                    scope.totalPartnersCount++;
                    partner.IsRemoved = true;
                    scope.getPartnerSearchResults();
                    scope.showInvalidEmailMessage = false;
                    scope.isSharingButtonActive = true;
                }

                scope.addReferral = function () {
                    scope.isSharingButtonActive = false;
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!re.test(String(scope.partnerSearch.addPartnerSearchValue).toLowerCase())) {
                        scope.showInvalidEmailMessage = true;
                        return;
                    }
                    scope.showInvalidEmailMessage = false;

                    var referralData = {
                        platformId: scope.workflowData.Entity.PlatformId,
                        siteConfigurationId: scope.workflowData.Entity.SiteConfigurationId,
                        referrerEntityId: scope.sessionData.EntityId,
                        objectType: 'Workflow',
                        objectId: scope.workflowData.Id,
                        objectReferralPath: scope.path,
                        objectReferralMessage: 'You were invited to share the project ' + scope.workflowData.Name
                    };

                    var basicPermissions = {
                        Permissions: {
                            View: true,
                            Edit: true,
                            Share: true,
                            Notes: true
                        }
                    };

                    platformEntityReferralDataService.createPlatformEntityReferral({
                        PlatformId: referralData.platformId,
                        SiteConfigurationId: referralData.siteConfigurationId,
                        EmailAddress: scope.partnerSearch.addPartnerSearchValue,
                        ReferralObject:
                        {
                            ReferrerEntityId: referralData.referrerEntityId,
                            ObjectType: referralData.objectType,
                            ObjectId: referralData.objectId,
                            ObjectReferralPath: referralData.objectReferralPath,
                            ObjectReferralMessage: referralData.objectReferralMessage,
                            ObjectReferralData: basicPermissions
                        }
                    }).then(function(data) {
                        if (data.ResponseType === 'Entity') {
                            // Add the direct connection
                            scope.addSharingConnection(data.Value);
                            scope.addPartnerForm.$setUntouched();
                            clearSearch();
                            return;
                        }

                        scope.expandedReferrals.push({
                            EmailAddress: scope.partnerSearch.addPartnerSearchValue,
                            Path: scope.path,
                            Data: basicPermissions
                        });
                        scope.totalPartnersCount++;
                        notifyService.notify('Your referral has been sent');
                        scope.addPartnerForm.$setUntouched();
                        clearSearch();
                        scope.isSharingButtonActive = true;
                    }).catch(function(error) {
                        console.error(error);
                        notifyService.notify('There was an error sending your referral', true);
                    });
                }
            }
        };
    }

    partnerSelector.$inject = ['$state', '$mdDialog', '$timeout', '$rootScope',
        'searchDataService', 'workflowStateService', 'notifyService',
        'mailRequestDataService', 'sessionDataService', 'platformEntityReferralDataService'];

    angular.module('ecap.workflow').directive('partnerSelector', partnerSelector);
})();

